/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Datetime: any;
  JSONObject: any;
  about_String_maxLength_1500: any;
  address_String_maxLength_255: any;
  bookingUrl_String_maxLength_1024: any;
  city_String_maxLength_255: any;
  countryCode_String_maxLength_255: any;
  country_String_maxLength_50: any;
  country_String_maxLength_255: any;
  currency_String_maxLength_20: any;
  customAddress_String_maxLength_255: any;
  description_String_maxLength_1500: any;
  email_String_NotNull_maxLength_320_format_email: any;
  email_String_maxLength_320: any;
  email_String_maxLength_320_format_email: any;
  image_String_maxLength_1024: any;
  kilojoules_Int_min_0_max_10000: any;
  label_String_maxLength_255: any;
  logo_String_maxLength_1024: any;
  mainImage_String_maxLength_1024: any;
  name_String_NotNull_maxLength_50: any;
  name_String_NotNull_maxLength_255: any;
  name_String_NotNull_minLength_1_maxLength_50: any;
  name_String_NotNull_minLength_1_maxLength_255: any;
  name_String_maxLength_255: any;
  name_String_minLength_1_maxLength_50: any;
  note_String_maxLength_255: any;
  path_String_maxLength_50_pattern_09az_: any;
  phone_String_maxLength_20: any;
  postcode_String_maxLength_255: any;
  price_Float_min_0_max_100000000: any;
  state_String_maxLength_255: any;
  subtitle_String_maxLength_255: any;
  timezone_String_maxLength_255: any;
  username_String_NotNull_minLength_3_maxLength_30_pattern_09az_: any;
  username_String_maxLength_30_pattern_09az_: any;
  website_String_maxLength_1024: any;
};

export type Account = {
  __typename?: 'Account';
  about: Maybe<Scalars['String']>;
  address: Maybe<Scalars['String']>;
  bookingUrl: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
  claimToken: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  cuisineType: Array<CuisineType>;
  currency: Maybe<Scalars['String']>;
  customAddress: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  facebookSyncPage: Maybe<AccountFacebookPage>;
  id: Scalars['Int'];
  invitation: Array<UserAccountInvitation>;
  isCleared: Maybe<Scalars['Boolean']>;
  latitude: Maybe<Scalars['Float']>;
  logo: Maybe<Scalars['String']>;
  logoList: Maybe<Array<Scalars['String']>>;
  longitude: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  note: Maybe<Scalars['String']>;
  openingHours: Array<OpeningHours>;
  orderLinks: Array<AccountLink>;
  owner: Maybe<User>;
  ownerId: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  planCanceledAt: Maybe<Scalars['DateTime']>;
  planCode: Maybe<Scalars['String']>;
  planExpiredAt: Maybe<Scalars['DateTime']>;
  postcode: Maybe<Scalars['String']>;
  requireDowngrade: Maybe<Scalars['Boolean']>;
  restaurantType: Maybe<RestaurantType>;
  siteDesign: Maybe<SiteDesign>;
  socialLinks: Array<AccountLink>;
  state: Maybe<Scalars['String']>;
  timezone: Maybe<Scalars['String']>;
  totalExtraImages: Maybe<Scalars['Int']>;
  totalInvite: Maybe<Scalars['Int']>;
  totalItems: Scalars['Int'];
  totalLiveMenu: Maybe<Scalars['Int']>;
  totalUsers: Scalars['Int'];
  username: Scalars['String'];
  users: Array<UserAccount>;
  webSetting: Maybe<AccountWebSetting>;
  website: Maybe<Scalars['String']>;
};

export type AccountFacebookPage = {
  __typename?: 'AccountFacebookPage';
  accountId: Scalars['Int'];
  errorData: Maybe<Scalars['String']>;
  invalidFields: Maybe<Scalars['String']>;
  lastError: Maybe<Scalars['String']>;
  lastSync: Maybe<Scalars['String']>;
  logo: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  pageId: Maybe<Scalars['String']>;
  syncFields: Maybe<Scalars['String']>;
};

export type AccountLink = {
  __typename?: 'AccountLink';
  id: Scalars['Int'];
  label: Maybe<Scalars['String']>;
  link: Scalars['String'];
  type: Scalars['String'];
};

export enum AccountLinkGroup {
  Order = 'ORDER',
  Social = 'SOCIAL'
}

export type AccountLinkInput = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
  type: Scalars['String'];
};

export enum AccountUserRole {
  Admin = 'ADMIN',
  Manager = 'MANAGER'
}

export enum AccountUserRoleInput {
  Admin = 'ADMIN'
}

export type AccountWebSetting = {
  __typename?: 'AccountWebSetting';
  customFaviconUrl: Maybe<Scalars['String']>;
  enableCustomFavicon: Maybe<Scalars['Boolean']>;
  showDefaultBranding: Maybe<Scalars['Boolean']>;
};

export type AccountWebSettingInput = {
  customFaviconUrl?: InputMaybe<Scalars['String']>;
  enableCustomFavicon?: InputMaybe<Scalars['Boolean']>;
  showDefaultBranding?: InputMaybe<Scalars['Boolean']>;
};

export type AccountWebSettingResult = {
  __typename?: 'AccountWebSettingResult';
  customFaviconUrl: Maybe<Scalars['String']>;
  enableCustomFavicon: Maybe<Scalars['Boolean']>;
  showDefaultBranding: Maybe<Scalars['Boolean']>;
};

export type AddAccountInput = {
  about?: InputMaybe<Scalars['about_String_maxLength_1500']>;
  address?: InputMaybe<Scalars['address_String_maxLength_255']>;
  bookingUrl?: InputMaybe<Scalars['bookingUrl_String_maxLength_1024']>;
  city?: InputMaybe<Scalars['city_String_maxLength_255']>;
  country?: InputMaybe<Scalars['country_String_maxLength_255']>;
  countryCode?: InputMaybe<Scalars['countryCode_String_maxLength_255']>;
  cuisineTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['currency_String_maxLength_20']>;
  customAddress?: InputMaybe<Scalars['customAddress_String_maxLength_255']>;
  email?: InputMaybe<Scalars['email_String_maxLength_320_format_email']>;
  latitude?: InputMaybe<Scalars['Float']>;
  logo?: InputMaybe<Scalars['logo_String_maxLength_1024']>;
  logoList?: InputMaybe<Array<Scalars['String']>>;
  longitude?: InputMaybe<Scalars['Float']>;
  name: Scalars['name_String_NotNull_minLength_1_maxLength_50'];
  note?: InputMaybe<Scalars['note_String_maxLength_255']>;
  openingHours?: InputMaybe<Array<OpeningHoursInput>>;
  orderLinks?: InputMaybe<Array<AccountLinkInput>>;
  phone?: InputMaybe<Scalars['phone_String_maxLength_20']>;
  postcode?: InputMaybe<Scalars['postcode_String_maxLength_255']>;
  restaurantTypeId?: InputMaybe<Scalars['Int']>;
  socialLinks?: InputMaybe<Array<AccountLinkInput>>;
  state?: InputMaybe<Scalars['state_String_maxLength_255']>;
  timezone?: InputMaybe<Scalars['timezone_String_maxLength_255']>;
  username: Scalars['username_String_NotNull_minLength_3_maxLength_30_pattern_09az_'];
  website?: InputMaybe<Scalars['website_String_maxLength_1024']>;
};

export type AddAccountResult = {
  __typename?: 'AddAccountResult';
  account: Maybe<Account>;
};

export type AddCategoryInput = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  designId: Scalars['Int'];
  name: Scalars['name_String_NotNull_minLength_1_maxLength_255'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export type AddCategoryResult = {
  __typename?: 'AddCategoryResult';
  category: Category;
};

export type AddDesignInput = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  designSettings?: InputMaybe<Scalars['JSONObject']>;
  elements?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['name_String_NotNull_maxLength_255'];
  path?: InputMaybe<Scalars['path_String_maxLength_50_pattern_09az_']>;
  themeId?: InputMaybe<Scalars['Int']>;
};

export type AddDesignResult = {
  __typename?: 'AddDesignResult';
  design: Design;
};

export type AddItemInput = {
  category?: InputMaybe<CategoryInput>;
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  labelIds?: InputMaybe<Array<Scalars['Int']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mainImage?: InputMaybe<Scalars['String']>;
  modifierIds?: InputMaybe<Array<Scalars['Int']>>;
  name: Scalars['name_String_NotNull_minLength_1_maxLength_255'];
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  subImages?: InputMaybe<Array<Scalars['String']>>;
  subtitle?: InputMaybe<Scalars['subtitle_String_maxLength_255']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  variations?: InputMaybe<Array<VariationInput>>;
};

export type AddLabelInput = {
  name: Scalars['name_String_NotNull_minLength_1_maxLength_50'];
};

export type AddLabelResult = {
  __typename?: 'AddLabelResult';
  label: ItemLabel;
  message: Maybe<Scalars['String']>;
};

export type AddModifierInput = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  image?: InputMaybe<Scalars['image_String_maxLength_1024']>;
  name: Scalars['name_String_NotNull_minLength_1_maxLength_255'];
  options?: InputMaybe<Array<ModifierOptionInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type AddModifierResult = {
  __typename?: 'AddModifierResult';
  modifier: Maybe<Modifier>;
};

export enum AppEnum {
  Core = 'CORE',
  Site = 'SITE'
}

export type Category = {
  __typename?: 'Category';
  children: Array<Category>;
  description: Maybe<Scalars['String']>;
  designId: Scalars['Int'];
  id: Scalars['Int'];
  items: Array<Item>;
  modifiers: Array<Modifier>;
  name: Scalars['String'];
  rank: Maybe<Scalars['Int']>;
};

export type CategoryConnectInput = {
  categoryId: Scalars['Int'];
};

export type CategoryCreateInput = {
  designId: Scalars['Int'];
  name: Scalars['String'];
};

export type CategoryInput = {
  connect?: InputMaybe<CategoryConnectInput>;
  create?: InputMaybe<CategoryCreateInput>;
};

export type CategoryRankInput = {
  children?: InputMaybe<Array<CategoryRankInput>>;
  id: Scalars['Int'];
  items?: InputMaybe<Array<RankInput>>;
  modifiers?: InputMaybe<Array<RankInput>>;
  rank: Scalars['Int'];
};

export type ClaimAccountResult = {
  __typename?: 'ClaimAccountResult';
  message: Scalars['String'];
};

export type ClearDesignResult = {
  __typename?: 'ClearDesignResult';
  account: Account;
  design: Design;
  message: Maybe<Scalars['String']>;
};

export type CreateCheckoutSessionInput = {
  app?: InputMaybe<AppEnum>;
  cancelUrl: Scalars['String'];
  sourceButton?: InputMaybe<Scalars['String']>;
  sourceUrl?: InputMaybe<Scalars['String']>;
  successUrl: Scalars['String'];
};

export type CreateCheckoutSessionResult = {
  __typename?: 'CreateCheckoutSessionResult';
  message: Scalars['String'];
  session: Maybe<StripeCheckoutSession>;
};

export type CuisineType = {
  __typename?: 'CuisineType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type DeleteAccountResult = {
  __typename?: 'DeleteAccountResult';
  message: Scalars['String'];
};

export type DeleteCategoryResult = {
  __typename?: 'DeleteCategoryResult';
  message: Scalars['String'];
};

export type DeleteDesignResult = {
  __typename?: 'DeleteDesignResult';
  message: Maybe<Scalars['String']>;
};

export type DeleteInvitationResult = {
  __typename?: 'DeleteInvitationResult';
  message: Scalars['String'];
};

export type DeleteItemResult = {
  __typename?: 'DeleteItemResult';
  message: Maybe<Scalars['String']>;
};

export type DeleteItemsFromCategoryResult = {
  __typename?: 'DeleteItemsFromCategoryResult';
  message: Scalars['String'];
};

export type DeleteModifierResult = {
  __typename?: 'DeleteModifierResult';
  message: Maybe<Scalars['String']>;
};

export type Design = {
  __typename?: 'Design';
  categories: Array<Category>;
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  designSettings: Scalars['JSONObject'];
  elements: Scalars['String'];
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  path: Scalars['String'];
  status: Maybe<DesignStatus>;
  theme: Maybe<Theme>;
  themeId: Maybe<Scalars['Int']>;
  thumbnail: Scalars['String'];
  updatedAt: Maybe<Scalars['DateTime']>;
};

export type DesignConnection = {
  __typename?: 'DesignConnection';
  edges: Array<DesignEdge>;
  pageInfo: Maybe<PageInfo>;
};

export type DesignEdge = {
  __typename?: 'DesignEdge';
  node: Design;
};

export enum DesignStatus {
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type DesignThemeMapping = {
  designId: Scalars['Int'];
  themeId: Scalars['Int'];
};

export type DowngradeAccountInput = {
  designId?: InputMaybe<Scalars['Int']>;
  invitationIds?: InputMaybe<Array<Scalars['Int']>>;
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
  userIds?: InputMaybe<Array<Scalars['String']>>;
};

export type DowngradeAccountResult = {
  __typename?: 'DowngradeAccountResult';
  account: Account;
  message: Scalars['String'];
};

export type EddItemsOfCategoryInput = {
  categoryId: Scalars['Int'];
  itemIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type EddItemsOfCategoryResult = {
  __typename?: 'EddItemsOfCategoryResult';
  message: Scalars['String'];
};

export type EditAccountInput = {
  patch: EditAccountInputPatch;
};

export type EditAccountInputPatch = {
  about?: InputMaybe<Scalars['about_String_maxLength_1500']>;
  address?: InputMaybe<Scalars['address_String_maxLength_255']>;
  bookingUrl?: InputMaybe<Scalars['bookingUrl_String_maxLength_1024']>;
  city?: InputMaybe<Scalars['city_String_maxLength_255']>;
  country?: InputMaybe<Scalars['country_String_maxLength_255']>;
  countryCode?: InputMaybe<Scalars['countryCode_String_maxLength_255']>;
  cuisineTypeIds?: InputMaybe<Array<Scalars['Int']>>;
  currency?: InputMaybe<Scalars['currency_String_maxLength_20']>;
  customAddress?: InputMaybe<Scalars['customAddress_String_maxLength_255']>;
  email?: InputMaybe<Scalars['email_String_maxLength_320']>;
  latitude?: InputMaybe<Scalars['Float']>;
  logo?: InputMaybe<Scalars['logo_String_maxLength_1024']>;
  logoList?: InputMaybe<Array<Scalars['String']>>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['name_String_minLength_1_maxLength_50']>;
  note?: InputMaybe<Scalars['note_String_maxLength_255']>;
  openingHours?: InputMaybe<Array<OpeningHoursInput>>;
  orderLinks?: InputMaybe<Array<AccountLinkInput>>;
  phone?: InputMaybe<Scalars['phone_String_maxLength_20']>;
  postcode?: InputMaybe<Scalars['postcode_String_maxLength_255']>;
  restaurantTypeId?: InputMaybe<Scalars['Int']>;
  socialLinks?: InputMaybe<Array<AccountLinkInput>>;
  state?: InputMaybe<Scalars['state_String_maxLength_255']>;
  timezone?: InputMaybe<Scalars['timezone_String_maxLength_255']>;
  username?: InputMaybe<Scalars['username_String_maxLength_30_pattern_09az_']>;
  users?: InputMaybe<Array<UserInput>>;
  webSetting?: InputMaybe<AccountWebSettingInput>;
  website?: InputMaybe<Scalars['website_String_maxLength_1024']>;
};

export type EditAccountResult = {
  __typename?: 'EditAccountResult';
  account: Maybe<Account>;
};

export type EditCategoryInput = {
  id: Scalars['Int'];
  patch: EditCategoryInputPatch;
};

export type EditCategoryInputPatch = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  name?: InputMaybe<Scalars['name_String_maxLength_255']>;
  parentId?: InputMaybe<Scalars['Int']>;
};

export type EditCategoryResult = {
  __typename?: 'EditCategoryResult';
  category: Category;
};

export type EditDesignInfoInput = {
  id: Scalars['Int'];
  patch: EditDesignInfoInputPatch;
};

export type EditDesignInfoInputPatch = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['name_String_maxLength_255']>;
  path?: InputMaybe<Scalars['path_String_maxLength_50_pattern_09az_']>;
  themeId?: InputMaybe<Scalars['Int']>;
};

export type EditDesignResult = {
  __typename?: 'EditDesignResult';
  design: Design;
};

export type EditDesignSettingsInput = {
  id: Scalars['Int'];
  patch: EditDesignSettingsInputPatch;
};

export type EditDesignSettingsInputPatch = {
  designSettings?: InputMaybe<Scalars['JSONObject']>;
  elements?: InputMaybe<Scalars['String']>;
  themeId?: InputMaybe<Scalars['Int']>;
};

export type EditFacebookPageInput = {
  accessToken?: InputMaybe<Scalars['String']>;
  syncFields: Scalars['String'];
};

export type EditItemInput = {
  id: Scalars['Int'];
  patch: EditItemInputPatch;
};

export type EditItemInputPatch = {
  category?: InputMaybe<CategoryInput>;
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  labelIds?: InputMaybe<Array<Scalars['Int']>>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  mainImage?: InputMaybe<Scalars['mainImage_String_maxLength_1024']>;
  modifierIds?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['name_String_maxLength_255']>;
  outOfStock?: InputMaybe<Scalars['Boolean']>;
  subImages?: InputMaybe<Array<Scalars['String']>>;
  subtitle?: InputMaybe<Scalars['subtitle_String_maxLength_255']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  variations?: InputMaybe<Array<VariationInput>>;
};

export type EditModifierInput = {
  id: Scalars['Int'];
  patch: EditModifierInputPatch;
};

export type EditModifierInputPatch = {
  description?: InputMaybe<Scalars['description_String_maxLength_1500']>;
  name?: InputMaybe<Scalars['name_String_maxLength_255']>;
  options?: InputMaybe<Array<ModifierOptionInput>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type EditModifierResult = {
  __typename?: 'EditModifierResult';
  modifier: Maybe<Modifier>;
};

export type EditModifiersOfCategoryInput = {
  categoryId: Scalars['Int'];
  modifierIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type EditModifiersOfCategoryResult = {
  __typename?: 'EditModifiersOfCategoryResult';
  message: Scalars['String'];
};

export type GeneralResult = {
  __typename?: 'GeneralResult';
  message: Maybe<Scalars['String']>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  country: Scalars['String'];
  lat: Scalars['Float'];
  lng: Scalars['Float'];
  timeZone: Scalars['String'];
};

export type InitDesignAccountInput = {
  country?: InputMaybe<Scalars['country_String_maxLength_50']>;
  email?: InputMaybe<Scalars['email_String_maxLength_320_format_email']>;
  name: Scalars['name_String_NotNull_maxLength_50'];
  restaurantTypeId?: InputMaybe<Scalars['Int']>;
};

export type InitDesignInput = {
  account: InitDesignAccountInput;
  menu?: InputMaybe<InitDesignMenuInput>;
  themeId?: InputMaybe<Scalars['Int']>;
};

export type InitDesignMenuInput = {
  name: Scalars['name_String_NotNull_maxLength_255'];
};

export type InitDesignResult = {
  __typename?: 'InitDesignResult';
  accountId: Scalars['Int'];
  designId: Scalars['Int'];
};

export type InviteUserInput = {
  email: Scalars['email_String_NotNull_maxLength_320_format_email'];
  role: AccountUserRoleInput;
};

export type InviteUserResult = {
  __typename?: 'InviteUserResult';
  invitation: Maybe<UserAccountInvitation>;
  message: Maybe<Scalars['String']>;
};

export type Item = {
  __typename?: 'Item';
  accountId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  labels: Array<ItemLabel>;
  mainImage: Maybe<Scalars['String']>;
  modifiers: Array<Modifier>;
  name: Scalars['String'];
  outOfStock: Scalars['Boolean'];
  status: Maybe<ItemStatus>;
  subImages: Array<Scalars['String']>;
  subtitle: Maybe<Scalars['String']>;
  tags: Array<Tag>;
  updatedAt: Maybe<Scalars['DateTime']>;
  variations: Array<Variation>;
};

export type ItemConnection = {
  __typename?: 'ItemConnection';
  edges: Array<ItemEdge>;
  pageInfo: Maybe<PageInfo>;
};

export type ItemEdge = {
  __typename?: 'ItemEdge';
  node: Item;
};

export type ItemLabel = {
  __typename?: 'ItemLabel';
  category: Maybe<ItemLabelCategory>;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum ItemLabelCategory {
  General = 'GENERAL',
  Spice = 'SPICE'
}

export enum ItemStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type ManageItemResult = {
  __typename?: 'ManageItemResult';
  category: Maybe<Category>;
  item: Item;
};

export type Menu = {
  __typename?: 'Menu';
  categories: Array<Category>;
  id: Scalars['Int'];
};

export type Modifier = {
  __typename?: 'Modifier';
  accountId: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image: Maybe<Scalars['String']>;
  max: Maybe<Scalars['Int']>;
  min: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  options: Array<ModifierOption>;
  tags: Array<Tag>;
};

export type ModifierConnection = {
  __typename?: 'ModifierConnection';
  edges: Array<ModifierEdge>;
  pageInfo: Maybe<PageInfo>;
};

export type ModifierEdge = {
  __typename?: 'ModifierEdge';
  node: Modifier;
};

export type ModifierOption = {
  __typename?: 'ModifierOption';
  createdAt: Maybe<Scalars['Datetime']>;
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image: Maybe<Scalars['String']>;
  isDefault: Scalars['Boolean'];
  item: Maybe<Item>;
  kilojoules: Maybe<Scalars['Int']>;
  modifierId: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  price: Maybe<Scalars['Float']>;
  rank: Maybe<Scalars['Int']>;
  refId: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ModifierOptionInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['Int']>;
  kilojoules?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  type: ModifierOptionType;
};

export enum ModifierOptionType {
  Item = 'ITEM',
  Modifier = 'MODIFIER'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAccount: Maybe<AddAccountResult>;
  addCategory: Maybe<AddCategoryResult>;
  addDesign: Maybe<AddDesignResult>;
  addItem: Maybe<ManageItemResult>;
  addLabel: Maybe<AddLabelResult>;
  addModifier: Maybe<AddModifierResult>;
  archiveItem: Maybe<GeneralResult>;
  claimAccount: ClaimAccountResult;
  clearDesignData: Maybe<ClearDesignResult>;
  createCheckoutSession: CreateCheckoutSessionResult;
  deleteCategory: Maybe<DeleteCategoryResult>;
  deleteDesign: Maybe<DeleteDesignResult>;
  deleteFacebookPage: AccountFacebookPage;
  deleteInvitation: Maybe<DeleteInvitationResult>;
  deleteItem: Maybe<DeleteItemResult>;
  deleteModifier: Maybe<DeleteModifierResult>;
  downgradeAccount: DowngradeAccountResult;
  editAccount: Maybe<EditAccountResult>;
  editCategory: Maybe<EditCategoryResult>;
  editDesignInfo: Maybe<EditDesignResult>;
  editDesignSettings: Maybe<EditDesignResult>;
  editFacebookPage: AccountFacebookPage;
  editItem: Maybe<ManageItemResult>;
  editItemsOfCategory: Maybe<EddItemsOfCategoryResult>;
  editModifier: Maybe<EditModifierResult>;
  editModifiersOfCategory: Maybe<EditModifiersOfCategoryResult>;
  initDesign: Maybe<InitDesignResult>;
  inviteUser: Maybe<InviteUserResult>;
  publishDesign: Maybe<PublishedDesignResult>;
  restoreItem: Maybe<GeneralResult>;
  siteAddDesign: SiteAddDesignResult;
  siteDeleteDesign: SiteDeleteDesignResult;
  siteEditDesignInfo: Maybe<SiteEditDesignInfoResult>;
  siteEditDesignSettings: Maybe<SiteEditDesignResult>;
  siteInitDesign: Maybe<SiteInitDesignResult>;
  sitePublishDesign: Maybe<SitePublishedDesignResult>;
  unPublishDesign: Maybe<PublishedDesignResult>;
  updateCategoriesRank: UpdateCategoriesRankResult;
};


export type MutationAddAccountArgs = {
  input: AddAccountInput;
};


export type MutationAddCategoryArgs = {
  input: AddCategoryInput;
};


export type MutationAddDesignArgs = {
  input: AddDesignInput;
};


export type MutationAddItemArgs = {
  input: AddItemInput;
};


export type MutationAddLabelArgs = {
  input: AddLabelInput;
};


export type MutationAddModifierArgs = {
  input: AddModifierInput;
};


export type MutationArchiveItemArgs = {
  itemId: Scalars['Int'];
};


export type MutationClaimAccountArgs = {
  accountId: Scalars['Int'];
  claimToken: Scalars['String'];
  isSite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationClearDesignDataArgs = {
  designId: Scalars['Int'];
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDesignArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteInvitationArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteItemArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteModifierArgs = {
  id: Scalars['Int'];
};


export type MutationDowngradeAccountArgs = {
  input: DowngradeAccountInput;
};


export type MutationEditAccountArgs = {
  input: EditAccountInput;
};


export type MutationEditCategoryArgs = {
  input: EditCategoryInput;
};


export type MutationEditDesignInfoArgs = {
  input: EditDesignInfoInput;
};


export type MutationEditDesignSettingsArgs = {
  input: EditDesignSettingsInput;
};


export type MutationEditFacebookPageArgs = {
  input: EditFacebookPageInput;
};


export type MutationEditItemArgs = {
  input: EditItemInput;
};


export type MutationEditItemsOfCategoryArgs = {
  input: EddItemsOfCategoryInput;
};


export type MutationEditModifierArgs = {
  input: EditModifierInput;
};


export type MutationEditModifiersOfCategoryArgs = {
  input: EditModifiersOfCategoryInput;
};


export type MutationInitDesignArgs = {
  input: InitDesignInput;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationPublishDesignArgs = {
  input: PublishDesignInput;
};


export type MutationRestoreItemArgs = {
  itemId: Scalars['Int'];
};


export type MutationSiteAddDesignArgs = {
  input: SiteAddDesignInput;
};


export type MutationSiteEditDesignInfoArgs = {
  input: SiteEditDesignInfoInput;
};


export type MutationSiteEditDesignSettingsArgs = {
  input: SiteEditDesignSettingsInput;
};


export type MutationSiteInitDesignArgs = {
  input: SiteInitDesignInput;
};


export type MutationSitePublishDesignArgs = {
  input: SitePublishDesignInput;
};


export type MutationUnPublishDesignArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateCategoriesRankArgs = {
  input: UpdateCategoriesRankInput;
};

export type OpeningHours = {
  __typename?: 'OpeningHours';
  allDay: Scalars['Boolean'];
  dayOfWeek: Scalars['Int'];
  id: Scalars['Int'];
  times: Array<Scalars['JSONObject']>;
};

export type OpeningHoursInput = {
  allDay?: InputMaybe<Scalars['Boolean']>;
  dayOfWeek?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  times?: InputMaybe<Array<InputMaybe<Scalars['JSONObject']>>>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  total: Scalars['Int'];
};

export type PublishDesignInput = {
  designId: Scalars['Int'];
  name?: InputMaybe<Scalars['name_String_maxLength_255']>;
  path?: InputMaybe<Scalars['path_String_maxLength_50_pattern_09az_']>;
  thumbnail?: InputMaybe<Scalars['String']>;
};

export type PublishedDesignResult = {
  __typename?: 'PublishedDesignResult';
  design: Design;
  message: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  UploadUrl: UploadUrlResult;
  account: Account;
  accountLabels: Array<ItemLabel>;
  accounts: Array<Account>;
  cuisineTypes: Array<CuisineType>;
  currentUser: Maybe<User>;
  design: Design;
  designs: DesignConnection;
  facebookPage: AccountFacebookPage;
  geoLocation: Maybe<GeoLocation>;
  invitations: Array<UserAccountInvitation>;
  item: Item;
  items: ItemConnection;
  labels: Array<ItemLabel>;
  modifier: Modifier;
  modifierOptions: Array<ModifierOption>;
  modifiers: ModifierConnection;
  restaurantTypes: Array<RestaurantType>;
  site: Maybe<SiteDesign>;
  siteThemes: Array<SiteTheme>;
  stripePortal: Maybe<StripePortal>;
  tag: Tag;
  tags: Array<Tag>;
  theme: Theme;
  themes: ThemeConnection;
};


export type QueryUploadUrlArgs = {
  contentType: Scalars['String'];
  fileName: Scalars['String'];
};


export type QueryAccountArgs = {
  id: Scalars['Int'];
};


export type QueryAccountLabelsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryCuisineTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryDesignArgs = {
  id: Scalars['Int'];
};


export type QueryDesignsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DesignStatus>;
};


export type QueryItemArgs = {
  id: Scalars['Int'];
};


export type QueryItemsArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryLabelsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryModifierArgs = {
  id: Scalars['Int'];
};


export type QueryModifierOptionsArgs = {
  modifierId: Scalars['Int'];
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


export type QueryModifiersArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']>>;
  keyword?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['Int']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryRestaurantTypesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryStripePortalArgs = {
  returnUrl: Scalars['String'];
};


export type QueryTagArgs = {
  id: Scalars['Int'];
};


export type QueryTagsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  keyword?: InputMaybe<Scalars['String']>;
};


export type QueryThemeArgs = {
  id: Scalars['Int'];
};


export type QueryThemesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type RankInput = {
  id: Scalars['Int'];
  rank: Scalars['Int'];
};

export type RestaurantType = {
  __typename?: 'RestaurantType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type SiteAddDesignInput = {
  themeId: Scalars['Int'];
};

export type SiteAddDesignResult = {
  __typename?: 'SiteAddDesignResult';
  message: Scalars['String'];
  siteDesign: SiteDesign;
};

export type SiteDeleteDesignResult = {
  __typename?: 'SiteDeleteDesignResult';
  message: Scalars['String'];
};

export type SiteDesign = {
  __typename?: 'SiteDesign';
  accountId: Scalars['ID'];
  colors: Scalars['JSONObject'];
  coverImage: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  designSettings: Scalars['JSONObject'];
  elements: Scalars['String'];
  fonts: Scalars['JSONObject'];
  links: Array<Scalars['JSONObject']>;
  orderLinks: Array<Scalars['JSONObject']>;
  publishedAt: Maybe<Scalars['DateTime']>;
  styles: Scalars['JSONObject'];
  theme: SiteTheme;
  themeId: Maybe<Scalars['Int']>;
  thumbnail: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['DateTime']>;
};

export enum SiteDesignStatus {
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type SiteEditDesignInfoInput = {
  path?: InputMaybe<Scalars['path_String_maxLength_50_pattern_09az_']>;
  status?: InputMaybe<SiteDesignStatus>;
};

export type SiteEditDesignInfoResult = {
  __typename?: 'SiteEditDesignInfoResult';
  message: Scalars['String'];
  siteDesign: SiteDesign;
};

export type SiteEditDesignResult = {
  __typename?: 'SiteEditDesignResult';
  siteDesign: SiteDesign;
};

export type SiteEditDesignSettingsInputPatch = {
  designSettings?: InputMaybe<Scalars['JSONObject']>;
  elements?: InputMaybe<Scalars['String']>;
  themeId?: InputMaybe<Scalars['Int']>;
};

export type SiteInitDesignInput = {
  account: InitDesignAccountInput;
  themeId: Scalars['Int'];
};

export type SiteInitDesignResult = {
  __typename?: 'SiteInitDesignResult';
  accountId: Scalars['Int'];
};

export type SiteMigrateAllDesignsResult = {
  __typename?: 'SiteMigrateAllDesignsResult';
  message: Scalars['String'];
};

export type SitePublishDesignInput = {
  path?: InputMaybe<Scalars['path_String_maxLength_50_pattern_09az_']>;
};

export type SitePublishedDesignResult = {
  __typename?: 'SitePublishedDesignResult';
  message: Scalars['String'];
  siteDesign: SiteDesign;
};

export type SiteTheme = {
  __typename?: 'SiteTheme';
  designSettings: Scalars['JSONObject'];
  elements: Scalars['String'];
  elementsClean: Maybe<Scalars['String']>;
  fixtures: Scalars['JSONObject'];
  id: Scalars['Int'];
  image: Scalars['String'];
  name: Scalars['String'];
};

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  url: Maybe<Scalars['String']>;
};

export type StripePortal = {
  __typename?: 'StripePortal';
  url: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  accountId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type Theme = {
  __typename?: 'Theme';
  designSettings: Scalars['JSONObject'];
  elements: Scalars['String'];
  fixtures: Scalars['JSONObject'];
  id: Scalars['Int'];
  image: Scalars['String'];
  isEmpty: Scalars['Boolean'];
  isFree: Scalars['Boolean'];
  isPopular: Scalars['Boolean'];
  name: Scalars['String'];
  previewUrl: Maybe<Scalars['String']>;
};

export type ThemeConnection = {
  __typename?: 'ThemeConnection';
  edges: Array<ThemeEdge>;
  pageInfo: Maybe<PageInfo>;
};

export type ThemeEdge = {
  __typename?: 'ThemeEdge';
  node: Theme;
};

export enum ThemeStatus {
  Draft = 'DRAFT',
  Live = 'LIVE'
}

export type UpdateCategoriesRankInput = {
  categories: Array<CategoryRankInput>;
  designId: Scalars['Int'];
};

export type UpdateCategoriesRankResult = {
  __typename?: 'UpdateCategoriesRankResult';
  message: Scalars['String'];
};

export type UpdateItemCategoryRankResult = {
  __typename?: 'UpdateItemCategoryRankResult';
  message: Scalars['String'];
};

export type UploadUrlResult = {
  __typename?: 'UploadUrlResult';
  url: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  email: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  picture: Maybe<Scalars['String']>;
  userId: Maybe<Scalars['String']>;
  username: Maybe<Scalars['String']>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  createdAt: Maybe<Scalars['DateTime']>;
  lastAccess: Maybe<Scalars['DateTime']>;
  role: Maybe<AccountUserRole>;
  user: Maybe<User>;
};

export type UserAccountInvitation = {
  __typename?: 'UserAccountInvitation';
  acceptedAt: Maybe<Scalars['DateTime']>;
  createdAt: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  expiryDate: Maybe<Scalars['DateTime']>;
  id: Maybe<Scalars['Int']>;
  role: Scalars['String'];
  status: UserAccountInvitationStatus;
};

export enum UserAccountInvitationStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export type UserInput = {
  role: AccountUserRole;
  userId: Scalars['String'];
};

export type Variation = {
  __typename?: 'Variation';
  createdAt: Scalars['DateTime'];
  defaultOption: Scalars['Boolean'];
  id: Scalars['Int'];
  itemId: Scalars['Int'];
  kilojoules: Maybe<Scalars['Int']>;
  label: Maybe<Scalars['String']>;
  price: Maybe<Scalars['Float']>;
};

export type VariationInput = {
  defaultOption?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  kilojoules?: InputMaybe<Scalars['kilojoules_Int_min_0_max_10000']>;
  label?: InputMaybe<Scalars['label_String_maxLength_255']>;
  price?: InputMaybe<Scalars['price_Float_min_0_max_100000000']>;
};

export type ExportDesignToThemeResult = {
  __typename?: 'exportDesignToThemeResult';
  designId: Scalars['Int'];
  themeId: Scalars['Int'];
};

export type SiteEditDesignSettingsInput = {
  patch: SiteEditDesignSettingsInputPatch;
};

export type BasicAccountFragment = { __typename?: 'Account', id: number, name: string, logo: string | null, username: string };

export type BasicUserFragment = { __typename?: 'User', userId: string | null, name: string | null, picture: string | null, email: string | null, firstName: string | null, lastName: string | null };

export type AccountFragment = { __typename?: 'Account', id: number, name: string, logo: string | null, about: string | null, username: string, email: string | null, website: string | null, bookingUrl: string | null, phone: string | null, address: string | null, latitude: number | null, longitude: number | null, note: string | null, city: string | null, state: string | null, country: string | null, countryCode: string | null, timezone: string | null, postcode: string | null, claimToken: string | null, isCleared: boolean | null, users: Array<{ __typename?: 'UserAccount', user: { __typename?: 'User', userId: string | null, name: string | null, picture: string | null, email: string | null, firstName: string | null, lastName: string | null } | null }>, invitation: Array<{ __typename?: 'UserAccountInvitation', id: number | null, email: string, status: UserAccountInvitationStatus, role: string, createdAt: any | null, acceptedAt: any | null, expiryDate: any | null }>, socialLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string }>, orderLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string, label: string | null }>, openingHours: Array<{ __typename?: 'OpeningHours', id: number, dayOfWeek: number, times: Array<any>, allDay: boolean }>, restaurantType: { __typename?: 'RestaurantType', id: number, name: string } | null, cuisineType: Array<{ __typename?: 'CuisineType', id: number, name: string }> };

export type EditAccountMutationVariables = Exact<{
  input: EditAccountInput;
}>;


export type EditAccountMutation = { __typename?: 'Mutation', editAccount: { __typename?: 'EditAccountResult', account: { __typename?: 'Account', id: number, name: string, logo: string | null, logoList: Array<string> | null, about: string | null, username: string, email: string | null, website: string | null, bookingUrl: string | null, phone: string | null, address: string | null, latitude: number | null, longitude: number | null, note: string | null, city: string | null, state: string | null, country: string | null, countryCode: string | null, timezone: string | null, postcode: string | null, users: Array<{ __typename?: 'UserAccount', user: { __typename?: 'User', userId: string | null, name: string | null, picture: string | null, email: string | null, firstName: string | null, lastName: string | null } | null }>, socialLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string }>, orderLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string, label: string | null }>, openingHours: Array<{ __typename?: 'OpeningHours', id: number, dayOfWeek: number, times: Array<any>, allDay: boolean }>, restaurantType: { __typename?: 'RestaurantType', id: number, name: string } | null, cuisineType: Array<{ __typename?: 'CuisineType', id: number, name: string }> } | null } | null };

export type ClaimAccountMutationVariables = Exact<{
  accountId: Scalars['Int'];
  claimToken: Scalars['String'];
}>;


export type ClaimAccountMutation = { __typename?: 'Mutation', claimAccount: { __typename?: 'ClaimAccountResult', message: string } };

export type CreateCheckoutSessionMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'CreateCheckoutSessionResult', message: string, session: { __typename?: 'StripeCheckoutSession', url: string | null } | null } };

export type EditSiteDesignMutationVariables = Exact<{
  input: SiteEditDesignSettingsInput;
}>;


export type EditSiteDesignMutation = { __typename?: 'Mutation', siteEditDesignSettings: { __typename?: 'SiteEditDesignResult', siteDesign: { __typename?: 'SiteDesign', accountId: string, elements: string, designSettings: any, themeId: number | null } } | null };

export type SiteInitSiteDesignMutationVariables = Exact<{
  input: SiteInitDesignInput;
}>;


export type SiteInitSiteDesignMutation = { __typename?: 'Mutation', siteInitDesign: { __typename?: 'SiteInitDesignResult', accountId: number } | null };

export type SitePublishDesignMutationVariables = Exact<{
  input: SitePublishDesignInput;
}>;


export type SitePublishDesignMutation = { __typename?: 'Mutation', sitePublishDesign: { __typename?: 'SitePublishedDesignResult', message: string, siteDesign: { __typename?: 'SiteDesign', thumbnail: string | null, accountId: string, elements: string, designSettings: any, themeId: number | null, createdAt: any, publishedAt: any | null } } | null };

export type SiteAddDesignMutationVariables = Exact<{
  input: SiteAddDesignInput;
}>;


export type SiteAddDesignMutation = { __typename?: 'Mutation', siteAddDesign: { __typename?: 'SiteAddDesignResult', message: string, siteDesign: { __typename?: 'SiteDesign', accountId: string, elements: string, designSettings: any, themeId: number | null, createdAt: any, publishedAt: any | null } } };

export type SiteEditDesignInfoMutationVariables = Exact<{
  input: SiteEditDesignInfoInput;
}>;


export type SiteEditDesignInfoMutation = { __typename?: 'Mutation', siteEditDesignInfo: { __typename?: 'SiteEditDesignInfoResult', message: string, siteDesign: { __typename?: 'SiteDesign', accountId: string, elements: string, designSettings: any, themeId: number | null, createdAt: any, publishedAt: any | null } } | null };

export type SiteDeleteDesignMutationVariables = Exact<{ [key: string]: never; }>;


export type SiteDeleteDesignMutation = { __typename?: 'Mutation', siteDeleteDesign: { __typename?: 'SiteDeleteDesignResult', message: string } };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAccountQuery = { __typename?: 'Query', account: { __typename?: 'Account', id: number, name: string, logo: string | null, logoList: Array<string> | null, about: string | null, username: string, email: string | null, website: string | null, bookingUrl: string | null, phone: string | null, address: string | null, customAddress: string | null, latitude: number | null, longitude: number | null, note: string | null, city: string | null, state: string | null, country: string | null, countryCode: string | null, timezone: string | null, postcode: string | null, claimToken: string | null, isCleared: boolean | null, planExpiredAt: any | null, planCode: string | null, users: Array<{ __typename?: 'UserAccount', user: { __typename?: 'User', userId: string | null, name: string | null, picture: string | null, email: string | null, firstName: string | null, lastName: string | null } | null }>, invitation: Array<{ __typename?: 'UserAccountInvitation', id: number | null, email: string, status: UserAccountInvitationStatus, role: string, createdAt: any | null, acceptedAt: any | null, expiryDate: any | null }>, socialLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string }>, orderLinks: Array<{ __typename?: 'AccountLink', id: number, type: string, link: string, label: string | null }>, openingHours: Array<{ __typename?: 'OpeningHours', id: number, dayOfWeek: number, times: Array<any>, allDay: boolean }>, restaurantType: { __typename?: 'RestaurantType', id: number, name: string } | null, cuisineType: Array<{ __typename?: 'CuisineType', id: number, name: string }>, siteDesign: { __typename?: 'SiteDesign', accountId: string, thumbnail: string | null, publishedAt: any | null, createdAt: any, updatedAt: any | null } | null, webSetting: { __typename?: 'AccountWebSetting', showDefaultBranding: boolean | null, enableCustomFavicon: boolean | null, customFaviconUrl: string | null } | null } };

export type GetAccountsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: number, name: string, logo: string | null, username: string }> };

export type GetAccountsWithSiteDesignQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetAccountsWithSiteDesignQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', id: number, name: string, logo: string | null, username: string, siteDesign: { __typename?: 'SiteDesign', accountId: string, publishedAt: any | null } | null }> };

export type GetRestaurantTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetRestaurantTypesQuery = { __typename?: 'Query', restaurantTypes: Array<{ __typename?: 'RestaurantType', id: number, name: string }> };

export type GetCuisineTypesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetCuisineTypesQuery = { __typename?: 'Query', cuisineTypes: Array<{ __typename?: 'CuisineType', id: number, name: string }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', userId: string | null, picture: string | null, name: string | null, username: string | null, email: string | null } | null };

export type GeoLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GeoLocationQuery = { __typename?: 'Query', geoLocation: { __typename?: 'GeoLocation', lat: number, lng: number, country: string } | null };

export type DesignDataFragment = { __typename?: 'Design', id: number, name: string, description: string | null, thumbnail: string, status: DesignStatus | null, path: string, elements: string, designSettings: any, isDefault: boolean, createdAt: any, updatedAt: any | null, themeId: number | null };

export type SiteDataFragment = { __typename?: 'SiteDesign', accountId: string, thumbnail: string | null, createdAt: any, updatedAt: any | null, publishedAt: any | null, elements: string, designSettings: any, themeId: number | null };

export type GetDesignDetailQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDesignDetailQuery = { __typename?: 'Query', design: { __typename?: 'Design', id: number, name: string, description: string | null, thumbnail: string, status: DesignStatus | null, path: string, elements: string, designSettings: any, isDefault: boolean, createdAt: any, updatedAt: any | null, themeId: number | null } };

export type GetDesignsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type GetDesignsQuery = { __typename?: 'Query', designs: { __typename?: 'DesignConnection', edges: Array<{ __typename?: 'DesignEdge', node: { __typename?: 'Design', id: number, name: string, description: string | null, thumbnail: string, status: DesignStatus | null, path: string, elements: string, designSettings: any, isDefault: boolean, createdAt: any, updatedAt: any | null, themeId: number | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, total: number } | null } };

export type GetSiteDesignQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSiteDesignQuery = { __typename?: 'Query', site: { __typename?: 'SiteDesign', accountId: string, thumbnail: string | null, createdAt: any, updatedAt: any | null, publishedAt: any | null, elements: string, designSettings: any, themeId: number | null } | null };

export type UploadUrlQueryVariables = Exact<{
  fileName: Scalars['String'];
  contentType: Scalars['String'];
}>;


export type UploadUrlQuery = { __typename?: 'Query', UploadUrl: { __typename?: 'UploadUrlResult', url: string } };

export type SiteThemeDataFragment = { __typename?: 'SiteTheme', id: number, image: string, elements: string, designSettings: any, elementsClean: string | null, fixtures: any };

export type GetThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetThemesQuery = { __typename?: 'Query', siteThemes: Array<{ __typename?: 'SiteTheme', id: number, image: string, elements: string, designSettings: any, elementsClean: string | null, fixtures: any }> };

export const BasicAccountFragmentDoc = gql`
    fragment BasicAccount on Account {
  id
  name
  logo
  username
}
    `;
export const BasicUserFragmentDoc = gql`
    fragment BasicUser on User {
  userId
  name
  picture
  email
  firstName
  lastName
}
    `;
export const AccountFragmentDoc = gql`
    fragment Account on Account {
  id
  name
  logo
  about
  username
  email
  website
  bookingUrl
  phone
  address
  latitude
  longitude
  note
  city
  state
  country
  countryCode
  timezone
  postcode
  claimToken
  isCleared
  users {
    user {
      userId
      name
      picture
      email
      firstName
      lastName
    }
  }
  invitation {
    id
    email
    status
    role
    createdAt
    acceptedAt
    role
    expiryDate
  }
  socialLinks {
    id
    type
    link
  }
  orderLinks {
    id
    type
    link
    label
  }
  openingHours {
    id
    dayOfWeek
    times
    allDay
  }
  restaurantType {
    id
    name
  }
  cuisineType {
    id
    name
  }
}
    `;
export const DesignDataFragmentDoc = gql`
    fragment DesignData on Design {
  id
  name
  description
  thumbnail
  status
  path
  elements
  designSettings
  isDefault
  createdAt
  updatedAt
  themeId
}
    `;
export const SiteDataFragmentDoc = gql`
    fragment SiteData on SiteDesign {
  accountId
  thumbnail
  createdAt
  updatedAt
  publishedAt
  elements
  designSettings
  themeId
}
    `;
export const SiteThemeDataFragmentDoc = gql`
    fragment SiteThemeData on SiteTheme {
  id
  image
  elements
  designSettings
  elementsClean
  fixtures
}
    `;
export const EditAccountDocument = gql`
    mutation EditAccount($input: EditAccountInput!) {
  editAccount(input: $input) {
    account {
      id
      name
      logo
      logoList
      about
      username
      email
      website
      bookingUrl
      phone
      address
      latitude
      longitude
      note
      city
      state
      country
      countryCode
      timezone
      postcode
      users {
        user {
          userId
          name
          picture
          email
          firstName
          lastName
        }
      }
      socialLinks {
        id
        type
        link
      }
      orderLinks {
        id
        type
        link
        label
      }
      openingHours {
        id
        dayOfWeek
        times
        allDay
      }
      restaurantType {
        id
        name
      }
      cuisineType {
        id
        name
      }
    }
  }
}
    `;
export type EditAccountMutationFn = Apollo.MutationFunction<EditAccountMutation, EditAccountMutationVariables>;

/**
 * __useEditAccountMutation__
 *
 * To run a mutation, you first call `useEditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAccountMutation, { data, loading, error }] = useEditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAccountMutation(baseOptions?: Apollo.MutationHookOptions<EditAccountMutation, EditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAccountMutation, EditAccountMutationVariables>(EditAccountDocument, options);
      }
export type EditAccountMutationHookResult = ReturnType<typeof useEditAccountMutation>;
export type EditAccountMutationResult = Apollo.MutationResult<EditAccountMutation>;
export type EditAccountMutationOptions = Apollo.BaseMutationOptions<EditAccountMutation, EditAccountMutationVariables>;
export const ClaimAccountDocument = gql`
    mutation ClaimAccount($accountId: Int!, $claimToken: String!) {
  claimAccount(accountId: $accountId, claimToken: $claimToken, isSite: true) {
    message
  }
}
    `;
export type ClaimAccountMutationFn = Apollo.MutationFunction<ClaimAccountMutation, ClaimAccountMutationVariables>;

/**
 * __useClaimAccountMutation__
 *
 * To run a mutation, you first call `useClaimAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimAccountMutation, { data, loading, error }] = useClaimAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      claimToken: // value for 'claimToken'
 *   },
 * });
 */
export function useClaimAccountMutation(baseOptions?: Apollo.MutationHookOptions<ClaimAccountMutation, ClaimAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimAccountMutation, ClaimAccountMutationVariables>(ClaimAccountDocument, options);
      }
export type ClaimAccountMutationHookResult = ReturnType<typeof useClaimAccountMutation>;
export type ClaimAccountMutationResult = Apollo.MutationResult<ClaimAccountMutation>;
export type ClaimAccountMutationOptions = Apollo.BaseMutationOptions<ClaimAccountMutation, ClaimAccountMutationVariables>;
export const CreateCheckoutSessionDocument = gql`
    mutation CreateCheckoutSession($input: CreateCheckoutSessionInput!) {
  createCheckoutSession(input: $input) {
    message
    session {
      url
    }
  }
}
    `;
export type CreateCheckoutSessionMutationFn = Apollo.MutationFunction<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;

/**
 * __useCreateCheckoutSessionMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutSessionMutation, { data, loading, error }] = useCreateCheckoutSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCheckoutSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>(CreateCheckoutSessionDocument, options);
      }
export type CreateCheckoutSessionMutationHookResult = ReturnType<typeof useCreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationResult = Apollo.MutationResult<CreateCheckoutSessionMutation>;
export type CreateCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const EditSiteDesignDocument = gql`
    mutation EditSiteDesign($input: siteEditDesignSettingsInput!) {
  siteEditDesignSettings(input: $input) {
    siteDesign {
      accountId
      elements
      designSettings
      themeId
    }
  }
}
    `;
export type EditSiteDesignMutationFn = Apollo.MutationFunction<EditSiteDesignMutation, EditSiteDesignMutationVariables>;

/**
 * __useEditSiteDesignMutation__
 *
 * To run a mutation, you first call `useEditSiteDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSiteDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSiteDesignMutation, { data, loading, error }] = useEditSiteDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSiteDesignMutation(baseOptions?: Apollo.MutationHookOptions<EditSiteDesignMutation, EditSiteDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSiteDesignMutation, EditSiteDesignMutationVariables>(EditSiteDesignDocument, options);
      }
export type EditSiteDesignMutationHookResult = ReturnType<typeof useEditSiteDesignMutation>;
export type EditSiteDesignMutationResult = Apollo.MutationResult<EditSiteDesignMutation>;
export type EditSiteDesignMutationOptions = Apollo.BaseMutationOptions<EditSiteDesignMutation, EditSiteDesignMutationVariables>;
export const SiteInitSiteDesignDocument = gql`
    mutation SiteInitSiteDesign($input: SiteInitDesignInput!) {
  siteInitDesign(input: $input) {
    accountId
  }
}
    `;
export type SiteInitSiteDesignMutationFn = Apollo.MutationFunction<SiteInitSiteDesignMutation, SiteInitSiteDesignMutationVariables>;

/**
 * __useSiteInitSiteDesignMutation__
 *
 * To run a mutation, you first call `useSiteInitSiteDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteInitSiteDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteInitSiteDesignMutation, { data, loading, error }] = useSiteInitSiteDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteInitSiteDesignMutation(baseOptions?: Apollo.MutationHookOptions<SiteInitSiteDesignMutation, SiteInitSiteDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteInitSiteDesignMutation, SiteInitSiteDesignMutationVariables>(SiteInitSiteDesignDocument, options);
      }
export type SiteInitSiteDesignMutationHookResult = ReturnType<typeof useSiteInitSiteDesignMutation>;
export type SiteInitSiteDesignMutationResult = Apollo.MutationResult<SiteInitSiteDesignMutation>;
export type SiteInitSiteDesignMutationOptions = Apollo.BaseMutationOptions<SiteInitSiteDesignMutation, SiteInitSiteDesignMutationVariables>;
export const SitePublishDesignDocument = gql`
    mutation sitePublishDesign($input: SitePublishDesignInput!) {
  sitePublishDesign(input: $input) {
    message
    siteDesign {
      thumbnail
      accountId
      elements
      designSettings
      themeId
      createdAt
      publishedAt
    }
  }
}
    `;
export type SitePublishDesignMutationFn = Apollo.MutationFunction<SitePublishDesignMutation, SitePublishDesignMutationVariables>;

/**
 * __useSitePublishDesignMutation__
 *
 * To run a mutation, you first call `useSitePublishDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitePublishDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitePublishDesignMutation, { data, loading, error }] = useSitePublishDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSitePublishDesignMutation(baseOptions?: Apollo.MutationHookOptions<SitePublishDesignMutation, SitePublishDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitePublishDesignMutation, SitePublishDesignMutationVariables>(SitePublishDesignDocument, options);
      }
export type SitePublishDesignMutationHookResult = ReturnType<typeof useSitePublishDesignMutation>;
export type SitePublishDesignMutationResult = Apollo.MutationResult<SitePublishDesignMutation>;
export type SitePublishDesignMutationOptions = Apollo.BaseMutationOptions<SitePublishDesignMutation, SitePublishDesignMutationVariables>;
export const SiteAddDesignDocument = gql`
    mutation siteAddDesign($input: SiteAddDesignInput!) {
  siteAddDesign(input: $input) {
    message
    siteDesign {
      accountId
      elements
      designSettings
      themeId
      createdAt
      publishedAt
    }
  }
}
    `;
export type SiteAddDesignMutationFn = Apollo.MutationFunction<SiteAddDesignMutation, SiteAddDesignMutationVariables>;

/**
 * __useSiteAddDesignMutation__
 *
 * To run a mutation, you first call `useSiteAddDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteAddDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteAddDesignMutation, { data, loading, error }] = useSiteAddDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteAddDesignMutation(baseOptions?: Apollo.MutationHookOptions<SiteAddDesignMutation, SiteAddDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteAddDesignMutation, SiteAddDesignMutationVariables>(SiteAddDesignDocument, options);
      }
export type SiteAddDesignMutationHookResult = ReturnType<typeof useSiteAddDesignMutation>;
export type SiteAddDesignMutationResult = Apollo.MutationResult<SiteAddDesignMutation>;
export type SiteAddDesignMutationOptions = Apollo.BaseMutationOptions<SiteAddDesignMutation, SiteAddDesignMutationVariables>;
export const SiteEditDesignInfoDocument = gql`
    mutation siteEditDesignInfo($input: SiteEditDesignInfoInput!) {
  siteEditDesignInfo(input: $input) {
    message
    siteDesign {
      accountId
      elements
      designSettings
      themeId
      createdAt
      publishedAt
    }
  }
}
    `;
export type SiteEditDesignInfoMutationFn = Apollo.MutationFunction<SiteEditDesignInfoMutation, SiteEditDesignInfoMutationVariables>;

/**
 * __useSiteEditDesignInfoMutation__
 *
 * To run a mutation, you first call `useSiteEditDesignInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteEditDesignInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteEditDesignInfoMutation, { data, loading, error }] = useSiteEditDesignInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSiteEditDesignInfoMutation(baseOptions?: Apollo.MutationHookOptions<SiteEditDesignInfoMutation, SiteEditDesignInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteEditDesignInfoMutation, SiteEditDesignInfoMutationVariables>(SiteEditDesignInfoDocument, options);
      }
export type SiteEditDesignInfoMutationHookResult = ReturnType<typeof useSiteEditDesignInfoMutation>;
export type SiteEditDesignInfoMutationResult = Apollo.MutationResult<SiteEditDesignInfoMutation>;
export type SiteEditDesignInfoMutationOptions = Apollo.BaseMutationOptions<SiteEditDesignInfoMutation, SiteEditDesignInfoMutationVariables>;
export const SiteDeleteDesignDocument = gql`
    mutation siteDeleteDesign {
  siteDeleteDesign {
    message
  }
}
    `;
export type SiteDeleteDesignMutationFn = Apollo.MutationFunction<SiteDeleteDesignMutation, SiteDeleteDesignMutationVariables>;

/**
 * __useSiteDeleteDesignMutation__
 *
 * To run a mutation, you first call `useSiteDeleteDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteDeleteDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteDeleteDesignMutation, { data, loading, error }] = useSiteDeleteDesignMutation({
 *   variables: {
 *   },
 * });
 */
export function useSiteDeleteDesignMutation(baseOptions?: Apollo.MutationHookOptions<SiteDeleteDesignMutation, SiteDeleteDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteDeleteDesignMutation, SiteDeleteDesignMutationVariables>(SiteDeleteDesignDocument, options);
      }
export type SiteDeleteDesignMutationHookResult = ReturnType<typeof useSiteDeleteDesignMutation>;
export type SiteDeleteDesignMutationResult = Apollo.MutationResult<SiteDeleteDesignMutation>;
export type SiteDeleteDesignMutationOptions = Apollo.BaseMutationOptions<SiteDeleteDesignMutation, SiteDeleteDesignMutationVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: Int!) {
  account(id: $id) {
    id
    name
    logo
    logoList
    about
    username
    email
    website
    bookingUrl
    phone
    address
    customAddress
    latitude
    longitude
    note
    city
    state
    country
    countryCode
    timezone
    postcode
    claimToken
    isCleared
    users {
      user {
        userId
        name
        picture
        email
        firstName
        lastName
      }
    }
    invitation {
      id
      email
      status
      role
      createdAt
      acceptedAt
      role
      expiryDate
    }
    socialLinks {
      id
      type
      link
    }
    orderLinks {
      id
      type
      link
      label
    }
    openingHours {
      id
      dayOfWeek
      times
      allDay
    }
    restaurantType {
      id
      name
    }
    cuisineType {
      id
      name
    }
    siteDesign {
      accountId
      thumbnail
      publishedAt
      createdAt
      updatedAt
    }
    planExpiredAt
    planCode
    webSetting {
      showDefaultBranding
      enableCustomFavicon
      customFaviconUrl
    }
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetAccountsDocument = gql`
    query GetAccounts($limit: Int, $offset: Int) {
  accounts(limit: $limit, offset: $offset) {
    ...BasicAccount
  }
}
    ${BasicAccountFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetAccountsWithSiteDesignDocument = gql`
    query GetAccountsWithSiteDesign($limit: Int, $offset: Int) {
  accounts(limit: $limit, offset: $offset) {
    ...BasicAccount
    siteDesign {
      accountId
      publishedAt
    }
  }
}
    ${BasicAccountFragmentDoc}`;

/**
 * __useGetAccountsWithSiteDesignQuery__
 *
 * To run a query within a React component, call `useGetAccountsWithSiteDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsWithSiteDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsWithSiteDesignQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetAccountsWithSiteDesignQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsWithSiteDesignQuery, GetAccountsWithSiteDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsWithSiteDesignQuery, GetAccountsWithSiteDesignQueryVariables>(GetAccountsWithSiteDesignDocument, options);
      }
export function useGetAccountsWithSiteDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsWithSiteDesignQuery, GetAccountsWithSiteDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsWithSiteDesignQuery, GetAccountsWithSiteDesignQueryVariables>(GetAccountsWithSiteDesignDocument, options);
        }
export type GetAccountsWithSiteDesignQueryHookResult = ReturnType<typeof useGetAccountsWithSiteDesignQuery>;
export type GetAccountsWithSiteDesignLazyQueryHookResult = ReturnType<typeof useGetAccountsWithSiteDesignLazyQuery>;
export type GetAccountsWithSiteDesignQueryResult = Apollo.QueryResult<GetAccountsWithSiteDesignQuery, GetAccountsWithSiteDesignQueryVariables>;
export const GetRestaurantTypesDocument = gql`
    query GetRestaurantTypes($limit: Int, $offset: Int) {
  restaurantTypes(limit: $limit, offset: $offset) {
    id
    name
  }
}
    `;

/**
 * __useGetRestaurantTypesQuery__
 *
 * To run a query within a React component, call `useGetRestaurantTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetRestaurantTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetRestaurantTypesQuery, GetRestaurantTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRestaurantTypesQuery, GetRestaurantTypesQueryVariables>(GetRestaurantTypesDocument, options);
      }
export function useGetRestaurantTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRestaurantTypesQuery, GetRestaurantTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRestaurantTypesQuery, GetRestaurantTypesQueryVariables>(GetRestaurantTypesDocument, options);
        }
export type GetRestaurantTypesQueryHookResult = ReturnType<typeof useGetRestaurantTypesQuery>;
export type GetRestaurantTypesLazyQueryHookResult = ReturnType<typeof useGetRestaurantTypesLazyQuery>;
export type GetRestaurantTypesQueryResult = Apollo.QueryResult<GetRestaurantTypesQuery, GetRestaurantTypesQueryVariables>;
export const GetCuisineTypesDocument = gql`
    query GetCuisineTypes($limit: Int, $offset: Int) {
  cuisineTypes(limit: $limit, offset: $offset) {
    id
    name
  }
}
    `;

/**
 * __useGetCuisineTypesQuery__
 *
 * To run a query within a React component, call `useGetCuisineTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCuisineTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCuisineTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetCuisineTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetCuisineTypesQuery, GetCuisineTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCuisineTypesQuery, GetCuisineTypesQueryVariables>(GetCuisineTypesDocument, options);
      }
export function useGetCuisineTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCuisineTypesQuery, GetCuisineTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCuisineTypesQuery, GetCuisineTypesQueryVariables>(GetCuisineTypesDocument, options);
        }
export type GetCuisineTypesQueryHookResult = ReturnType<typeof useGetCuisineTypesQuery>;
export type GetCuisineTypesLazyQueryHookResult = ReturnType<typeof useGetCuisineTypesLazyQuery>;
export type GetCuisineTypesQueryResult = Apollo.QueryResult<GetCuisineTypesQuery, GetCuisineTypesQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    userId
    picture
    name
    username
    email
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GeoLocationDocument = gql`
    query GeoLocation {
  geoLocation {
    lat
    lng
    country
  }
}
    `;

/**
 * __useGeoLocationQuery__
 *
 * To run a query within a React component, call `useGeoLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeoLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeoLocationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGeoLocationQuery(baseOptions?: Apollo.QueryHookOptions<GeoLocationQuery, GeoLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeoLocationQuery, GeoLocationQueryVariables>(GeoLocationDocument, options);
      }
export function useGeoLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeoLocationQuery, GeoLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeoLocationQuery, GeoLocationQueryVariables>(GeoLocationDocument, options);
        }
export type GeoLocationQueryHookResult = ReturnType<typeof useGeoLocationQuery>;
export type GeoLocationLazyQueryHookResult = ReturnType<typeof useGeoLocationLazyQuery>;
export type GeoLocationQueryResult = Apollo.QueryResult<GeoLocationQuery, GeoLocationQueryVariables>;
export const GetDesignDetailDocument = gql`
    query GetDesignDetail($id: Int!) {
  design(id: $id) {
    ...DesignData
  }
}
    ${DesignDataFragmentDoc}`;

/**
 * __useGetDesignDetailQuery__
 *
 * To run a query within a React component, call `useGetDesignDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDesignDetailQuery(baseOptions: Apollo.QueryHookOptions<GetDesignDetailQuery, GetDesignDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignDetailQuery, GetDesignDetailQueryVariables>(GetDesignDetailDocument, options);
      }
export function useGetDesignDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignDetailQuery, GetDesignDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignDetailQuery, GetDesignDetailQueryVariables>(GetDesignDetailDocument, options);
        }
export type GetDesignDetailQueryHookResult = ReturnType<typeof useGetDesignDetailQuery>;
export type GetDesignDetailLazyQueryHookResult = ReturnType<typeof useGetDesignDetailLazyQuery>;
export type GetDesignDetailQueryResult = Apollo.QueryResult<GetDesignDetailQuery, GetDesignDetailQueryVariables>;
export const GetDesignsDocument = gql`
    query GetDesigns($limit: Int, $offset: Int) {
  designs(limit: $limit, offset: $offset) {
    edges {
      node {
        ...DesignData
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      total
    }
  }
}
    ${DesignDataFragmentDoc}`;

/**
 * __useGetDesignsQuery__
 *
 * To run a query within a React component, call `useGetDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDesignsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDesignsQuery(baseOptions?: Apollo.QueryHookOptions<GetDesignsQuery, GetDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDesignsQuery, GetDesignsQueryVariables>(GetDesignsDocument, options);
      }
export function useGetDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDesignsQuery, GetDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDesignsQuery, GetDesignsQueryVariables>(GetDesignsDocument, options);
        }
export type GetDesignsQueryHookResult = ReturnType<typeof useGetDesignsQuery>;
export type GetDesignsLazyQueryHookResult = ReturnType<typeof useGetDesignsLazyQuery>;
export type GetDesignsQueryResult = Apollo.QueryResult<GetDesignsQuery, GetDesignsQueryVariables>;
export const GetSiteDesignDocument = gql`
    query GetSiteDesign {
  site {
    ...SiteData
  }
}
    ${SiteDataFragmentDoc}`;

/**
 * __useGetSiteDesignQuery__
 *
 * To run a query within a React component, call `useGetSiteDesignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDesignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDesignQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSiteDesignQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteDesignQuery, GetSiteDesignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDesignQuery, GetSiteDesignQueryVariables>(GetSiteDesignDocument, options);
      }
export function useGetSiteDesignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDesignQuery, GetSiteDesignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDesignQuery, GetSiteDesignQueryVariables>(GetSiteDesignDocument, options);
        }
export type GetSiteDesignQueryHookResult = ReturnType<typeof useGetSiteDesignQuery>;
export type GetSiteDesignLazyQueryHookResult = ReturnType<typeof useGetSiteDesignLazyQuery>;
export type GetSiteDesignQueryResult = Apollo.QueryResult<GetSiteDesignQuery, GetSiteDesignQueryVariables>;
export const UploadUrlDocument = gql`
    query UploadUrl($fileName: String!, $contentType: String!) {
  UploadUrl(fileName: $fileName, contentType: $contentType) {
    url
  }
}
    `;

/**
 * __useUploadUrlQuery__
 *
 * To run a query within a React component, call `useUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadUrlQuery({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      contentType: // value for 'contentType'
 *   },
 * });
 */
export function useUploadUrlQuery(baseOptions: Apollo.QueryHookOptions<UploadUrlQuery, UploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadUrlQuery, UploadUrlQueryVariables>(UploadUrlDocument, options);
      }
export function useUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadUrlQuery, UploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadUrlQuery, UploadUrlQueryVariables>(UploadUrlDocument, options);
        }
export type UploadUrlQueryHookResult = ReturnType<typeof useUploadUrlQuery>;
export type UploadUrlLazyQueryHookResult = ReturnType<typeof useUploadUrlLazyQuery>;
export type UploadUrlQueryResult = Apollo.QueryResult<UploadUrlQuery, UploadUrlQueryVariables>;
export const GetThemesDocument = gql`
    query GetThemes {
  siteThemes {
    ...SiteThemeData
  }
}
    ${SiteThemeDataFragmentDoc}`;

/**
 * __useGetThemesQuery__
 *
 * To run a query within a React component, call `useGetThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThemesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetThemesQuery(baseOptions?: Apollo.QueryHookOptions<GetThemesQuery, GetThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThemesQuery, GetThemesQueryVariables>(GetThemesDocument, options);
      }
export function useGetThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetThemesQuery, GetThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThemesQuery, GetThemesQueryVariables>(GetThemesDocument, options);
        }
export type GetThemesQueryHookResult = ReturnType<typeof useGetThemesQuery>;
export type GetThemesLazyQueryHookResult = ReturnType<typeof useGetThemesLazyQuery>;
export type GetThemesQueryResult = Apollo.QueryResult<GetThemesQuery, GetThemesQueryVariables>;